import {Component, computed, input} from '@angular/core';
import {NgClass, NgOptimizedImage} from "@angular/common";
import {PillColor, PillType} from "../models";
import {Size} from '../../services/model';

@Component({
  selector: 'lib-pill-logo',
  imports: [
    NgOptimizedImage,
    NgClass
  ],
  templateUrl: './pill-logo.component.html',
  styleUrl: './pill-logo.component.scss'
})
export class PillLogoComponent {
  companyName = input.required<string>();
  companyLogo = input<string>();
  size = input<Size>(Size.SMALL);
  color = input<PillColor>();
  type = input<PillType>(PillType.NORMAL);

  pillClass = computed(() => {
    if (!this.color()) {
      return {small: this.size() === Size.SMALL};
    }

    return {
      [this.getColorClass(this.color()!)]: true,
      small: this.size() === Size.SMALL,
      [this.type().toLowerCase()]: true
    };
  });

  private getColorClass(color: PillColor): string {
    switch (color) {
      case PillColor.ORANGE_LIGHT:
        return 'ticket-pill';
      case PillColor.NEUTRAL_200:
        return 'grey-pill';
      case PillColor.HIGH_CONTRAST:
        return 'high-contrast';
      default:
        return 'ticket-pill';
    }
  }
}
